import axios from 'axios';

import cfac22 from '../cfac22';

export function processOrder(uId, orderObject, consumed) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(
        `${cfac22('API_HOST_V2')}/order/processOrder`,
        {
          orderObject,
          consumed

          /* Compõe o orderObject
             - itemId,
             - receiver,
             - requestDate,
             - requestLat,
             - requestLon,
             - sender,
                 - type,
            */
        },
        { headers: { 'Full-Url': window.location.href }, withCredentials: true }
      ).
      then((result) => {
        resolve(result.data.response);
      }).
      catch((error) => {
        return reject(error.response.data.error);
      });
    }).
    catch((error) => {
      reject(error);
    });
  });
}
